export const getSelectOptionsFromVariants = (variants) => variants.map((variant) => ({
    label: variant.attributesDescription,
    value: variant.id,
    quantity: variant.quantity,
}));
